<template>
  <div>
    <el-dialog
      :title="title"
      :visible.sync="visible"
      width="700px"
      append-to-body
      :before-close="handleCancel"
      :close-on-click-modal="false"
      class="sectionDialog"
    >
      <el-form
        ref="sectionForm"
        :model="sectionForm"
        label-width="105px"
        :rules="sectionFormRules"
        @submit.native.prevent
      >
        <el-form-item label="节名称：" prop="sectionName">
          <el-input
            v-model.trim="sectionForm.sectionName"
            placeholder="请输入节名称"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item label="主讲讲师：" required>
          <div style="margin-top:8px">
            <el-radio-group v-model="teacherType">
              <el-radio :label="0">平台内讲师</el-radio>
              <el-radio :label="1">其他讲师</el-radio>
            </el-radio-group>
            <el-form-item :prop="teacherType == 0 ? 'teacherId' : 'teacherName'">
              <el-select
                v-if="teacherType == 0"
                v-model="sectionForm.teacherId"
                filterable
                placeholder="请选择主讲讲师"
                clearable
                @change="teacherChange"
              >
                <el-option
                  v-for="option in teacherList"
                  :key="option.teacherId"
                  :value="option.teacherId"
                  :label="option.teacherName"
                >
                </el-option>
              </el-select>
              <el-input
                v-if="teacherType == 1"
                v-model.trim="sectionForm.teacherName"
                placeholder="请输入讲师名称"
                clearable
              ></el-input>
            </el-form-item>
          </div>
        </el-form-item>
        <el-form-item
          v-if="section.sectionId"
          ref="coverImageUrl"
          label="封面图片："
          prop="coverImageUrl"
        >
          <el-upload
            class="cover-uploader"
            action=""
            :show-file-list="false"
            :before-upload="handleCoverBeforeUpload"
            accept=".jpg,.jpeg,.png,.JPG,.JPEG"
          >
            <img
              v-if="sectionForm.coverImageUrl"
              :src="sectionForm.coverImageUrl"
              class="cover-preview"
            />
            <i v-else class="el-icon-upload"></i>
          </el-upload>
        </el-form-item>
        <el-form-item ref="materialType" label="素材类型：" prop="materialType">
          <div class="type">
            <el-radio-group v-model="sectionForm.materialType">
              <el-radio :label="1">视频</el-radio>
            </el-radio-group>
          </div>
        </el-form-item>
        <el-form-item label="上传素材：">
          <el-upload
            action="/api/course/supply/offline/course/upload/video"
            :on-success="handleUploadSuccess"
            :on-error="handleUploadError"
            :file-list="fileList"
            :limit="1"
            :on-remove="handleUploadFileRemove"
            :on-change="handleFileChange"
            :before-upload="beforeAvatarUpload"
            accept=".mp4,.Mp4"
            :disabled="sectionForm.isProduct"
          >
            <el-button>选择上传素材</el-button>
            <p slot="tip" class="VideoTip">
              视频支持.MP4格式，大小在20MB内
            </p>
          </el-upload>
          <el-button v-if="sectionForm.videoUrl" class="preview" @click="handleOpenVideoPreview"
            >素材预览</el-button
          >
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button :loading="uploading" @click="handleCancel">取 消</el-button>
        <el-button type="primary" :loading="uploading" @click="addSection">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      class="videoReviewDialog"
      width="800px"
      :visible.sync="videoVisible"
      title="预览"
      :before-close="closeVideoDialog"
      :close-on-click-modal="false"
    >
      <video v-if="videoVisible" :src="currentVideoSrc" controls></video>
    </el-dialog>
    <CropperModal ref="cropperModal" @cropped="handleCropped" />
  </div>
</template>
<script>
import {
  courseSectionSave,
  courseSectionDetail,
  courseSectionUpdate,
  courseTeacherFilter,
} from '@/api/course'
import { getFileUpload } from '@/api/college'
import to from 'await-to'
import { mapGetters } from 'vuex'
import CropperModal from './CropperModal'
export default {
  name: 'SectionAdd',
  components: { CropperModal },
  props: {
    section: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      visible: false,
      sectionForm: {},
      fileList: [],
      courseId: this.$route.params.courseId,
      title: '新增节',
      videoVisible: false,
      currentVideoSrc: '',
      uploading: false,
      teacherList: [],
      teacherType: 0,
    }
  },
  computed: {
    ...mapGetters(['userInfo']),
    sectionFormRules() {
      const rules = {
        sectionName: [{ required: true, message: '请输入节名称', trigger: 'blur' }],
        teacherId: [{ required: true, message: '请选择主讲讲师', trigger: 'change' }],
        teacherName: [{ required: true, message: '请输入讲师名称', trigger: 'blur' }],
        materialType: [{ required: true, message: '请选择素材类型', trigger: 'change' }],
      }
      if (this.section.sectionId) {
        rules.coverImageUrl = [{ required: true, message: '请上传封面图片', trigger: 'change' }]
      }
      return rules
    },
  },
  watch: {
    teacherType() {
      this.$nextTick(() => {
        this.$refs.sectionForm.clearValidate(['teacherId', 'teacherName'])
      })
    },
  },
  methods: {
    show() {
      this.fileList = []
      this.title = '新增节'
      this.sectionForm = {
        teacherId: '',
        teacherName: '',
      }
      this.teacherType = 0
      this.visible = true
      this.getTeacherList()
      if (this.section.sectionId) {
        this.title = '编辑节'
        this.handleGetSectionInfo(this.section.sectionId)
      }
    },
    async getTeacherList() {
      const [res, err] = await to(courseTeacherFilter({ courseId: this.courseId }))
      if (err) return this.$message.warning(err.msg)
      this.teacherList = res.data
    },
    teacherChange(e) {
      this.$forceUpdate()
      this.sectionForm.teacherId = e
    },
    async handleGetSectionInfo(sectionId) {
      const [res, err] = await to(courseSectionDetail({ courseId: this.courseId, id: sectionId }))
      if (err) return this.$message.warning(err.msg)
      this.sectionForm = res.data
      this.$set(this.sectionForm, 'materialType', res.data.materialCategory)
      if (res.data.teacherId) {
        this.teacherType = 0
      } else if (res.data.teacherName) {
        this.teacherType = 1
      }
      if (this.sectionForm.videoUrl) {
        this.fileList.push({
          url: this.sectionForm.videoUrl,
          name: this.sectionForm.videoName,
        })
      }
    },
    beforeAvatarUpload(file) {
      const isMp4 = file.name.toLowerCase().endsWith('.mp4')
      if (!isMp4) {
        this.$message.error('上传文件格式必须为 MP4!')
      } else {
        this.uploading = true
      }
      return isMp4
    },
    handleCoverBeforeUpload(file) {
      const isImage = file.type.includes('image')
      if (!isImage) {
        this.$message.error('上传文件类型必须是图片!')
        return false
      }
      const reader = new FileReader()
      reader.onload = e => {
        this.$refs.cropperModal.open(e.target.result)
      }
      reader.readAsDataURL(file)
      return false
    },
    async handleCropped(file) {
      const params = new FormData()
      params.append('fileTypeCode', 'F001')
      params.append('file', file)
      params.append('fileName', file.name)
      const [res, err] = await to(getFileUpload(params))
      if (err) {
        return this.$message.error(err.msg)
      }
      this.$set(this.sectionForm, 'coverImageUrl', res.data)
      this.$refs.coverImageUrl.clearValidate()
    },
    handleUploadFileRemove() {
      this.$set(this.sectionForm, 'videoId', '')
      this.$set(this.sectionForm, 'videoUrl', '')
      this.$set(this.sectionForm, 'materialId', '')
      this.fileList = []
    },
    handleUploadSuccess(response) {
      this.uploading = false
      this.$set(this.sectionForm, 'videoId', response.data.videoId)
      this.$set(this.sectionForm, 'videoUrl', response.data.videoUrl)
      this.$set(this.sectionForm, 'materialId', response.data.materialId)
      this.$message.success('上传成功')
    },
    handleUploadError() {
      this.uploading = false
      this.$message.error('上传失败')
    },
    handleFileChange(file, fileList) {
      this.fileList = fileList
    },
    async addSection() {
      if (!this.fileList.length) {
        return this.$message.warning('请上传素材!')
      }
      this.$set(this.sectionForm, 'videoName', this.fileList[0].name)
      if (this.teacherType == 0) {
        this.sectionForm.teacherName = ''
      } else {
        this.sectionForm.teacherId = ''
      }
      this.$refs['sectionForm'].validate(async valid => {
        if (valid) {
          if (this.section.sectionId) {
            const [, err] = await to(
              courseSectionUpdate({
                courseId: this.courseId,
                id: this.section.sectionId,
                ...this.sectionForm,
              }),
            )
            if (err) return this.$message.warning(err.msg)
            this.$emit('success')
            this.visible = false
          } else {
            const [, err] = await to(
              courseSectionSave({
                chapterId: this.section.chapterId,
                ...this.sectionForm,
                videoPlatform: 5,
              }),
            )
            if (err) return this.$message.warning(err.msg)
            this.$emit('success')
            this.visible = false
          }
        }
      })
    },
    handleCancel() {
      this.visible = false
      this.$emit('close')
    },
    handleOpenVideoPreview() {
      this.videoVisible = true
      this.currentVideoSrc = this.sectionForm.videoUrl
    },
    closeVideoDialog() {
      this.videoVisible = false
      this.currentVideoSrc = ''
    },
  },
}
</script>
<style lang="scss" scoped>
.sectionDialog {
  ::v-deep .el-input {
    width: 300px !important;
  }
  ::v-deep .el-dialog__body {
    .el-radio-group {
      margin-bottom: 20px;
    }
    .uploader {
      height: 92px;
      .el-upload {
        width: 180px;
        height: 100%;
        background: #f5f5f5;
        border-radius: 5px;
      }
      .el-upload-list__item {
        width: 180px;
        height: 100%;
      }
    }
    .cover-uploader {
      .el-upload {
        width: 180px;
        height: 92px;
        border: 1px dashed #d9d9d9;
        border-radius: 6px;
        background: #f5f5f5;
        display: flex;
        align-items: center;
        justify-content: center;
        overflow: hidden;
        &:hover {
          border-color: #ff7b33;
        }
        .cover-preview {
          width: 100%;
          height: 100%;
          object-fit: cover;
        }
        .el-icon-upload {
          font-size: 58px;
          color: #8c939d;
        }
      }
    }
    .type {
      .el-radio {
        padding-top: 12px;
      }
    }

    .el-button {
      margin-left: 0px;
    }
    .preview {
      margin-top: 10px;
      width: 80px;
      height: 30px;
    }
    .VideoTip {
      margin-top: 12px;
      font-size: 14px;
      line-height: 14px;
      color: #909399;
    }
    .btnCss {
      border: none !important;
      color: #606266;
      cursor: default;
      text-align: left;
      &:hover {
        background: #ffffff;
      }
    }
  }
  ::v-deep .el-dialog__footer {
    .el-button {
      width: 110px;
    }
  }
}
.videoReviewDialog {
  video {
    width: 100%;
    height: 440px;
  }
}
</style>
